import { atom } from "recoil";

export const actionLists = atom({
  key: "actionLists",
  default: [],
});
